import { DadataAddressService } from './AddressService'
import type { HttpClient } from '~/shared/api'

export class DadataService {
  readonly address: DadataAddressService

  constructor(http: HttpClient, dadataBaseUri: string) {
    this.address = new DadataAddressService(http, dadataBaseUri)
  }
}
